<template>
  <div class="container">
    <div class="header">
      <formSearch
        :tableSearch="tableSearch"
        @handleSearch="handleSearch"
        @handleReset="handleReset"
        :validDefault="true"
        ref="search"
      ></formSearch>
    </div>
    <div class="footer">
      <Rectangle :path="require('@/assets/img/common/rectangle.png')" />
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div style="display: flex; align-items: center">
          <TipsLabel
            :tip="'总条数统计：'"
            :count="tableLg"
            style="margin-right: 49px"
          />
          <TipsLabel
            :tip="'汇总金额统计：'"
            :count="`${totalAmount}元`"
            style="margin-right: 49px"
            :countColor="'#F45B4A'"
          />
          <TipsLabel
            :tip="'勾选汇总金额统计：'"
            :count="`${checkedAmount}元`"
            :countColor="'#F45B4A'"
          />
        </div>
        <div style="margin-bottom: 20px; display: flex; align-items: center">
          <!-- <el-upload
            accept="image/jpeg,image/png,image/jpg.xls,.xlse,pdf"
            action="http://128.192.182.163/scm/ac/accounts/resource/synchronal"
            :limit="1"
            :on-success="uploadSuccess2"
            :on-error="upError"
            :file-list="fileList2"
            :show-file-list="false"
            :auto-upload="true"
          >
            <blueBtn :name="'同步数据'" :width="96" class="btn3" />
          </el-upload> -->
          <!-- <blueBtn :name="'同步数据'" 
          :loading="isLoading"
          :width="96" class="btn2" @btnClick="uploadData"/> -->
          <div>
          <el-dialog
              title="文件导入"
              :visible.sync="dialogTableVisible"
              width="40%"
            >
              <div style="margin-bottom: 20px; display: flex; align-items: center">
                <el-upload
                  class="upload-demo"
                  accept=""
                  :action="`${baseUrl}/ac/accounts/resource/synchronal`"
                  :http-request="myUploadMethod"
                  :on-success="uploadSuccess2"
                  :on-error="upError"
                  :file-list="fileList2"
                  :show-file-list="false"
                  :auto-upload="true">
                      <blueBtn :name="'数据导入'" :width="96" class="btn2"
                      v-loading="buttonLoading"/>
                </el-upload>
                <blueBtn :name="'模板下载'" :width="96" @btnClick="templateDownload" 
                class="btn2"/>
              </div>
              <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button> -->
            </span>
            </el-dialog>
            <iconBtn
                    :name="'导入'"
                    :width="71"
                    @btnClick="handleImport"
                    :path="require('@/assets/img/common/modify.png')"
                    class="btn3"/>
          </div>
          <iconBtn
            :name="'导出'"
            v-loading="exportFileLoading"
            :width="71"
            @btnClick="exportData"
            :path="require('@/assets/submember/daochu.png')"
            style="float: right"
          />
        </div>
      </div>
      <Table :tableProp="tableProp" :tableData="tableData" 
          @SelectionChange="handleChange"
      :isOrderNo="true" :isLoading="loading" :page="pageObj">
        <template slot="edit" slot-scope="scope">
          <div
            @click="handleEdit(scope.index, scope.row)"
            style="color: #1b5bbf; cursor: pointer"
          >
            详情
          </div>
        </template>
      </Table>
      <Pagination
        v-if="Number(tableLg) > 0"
        :page="pageObj"
        @setcurrentpage="setPage"
        :pageSizes="pageSizes"
        layout="prev, pager, next, sizes"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import formSearch from "@/components/public/Element/formSearch";
import Table from "@/components/public/Element/ElTable.vue";
import blueBtn from "@/components/public/Element/ElNormalButton.vue";
import iconBtn from "@/components/public/Element/ELIconButton.vue";
import Rectangle from "@/components/public/Element/rectangle.vue";
import TipsLabel from "@/components/public/Element/tipsLabel.vue";
import Pagination from "@/components/public/Element/Pagination";
import utif from "@/utif/utif";
import { getNamesProps } from "@/utif/utif.js";

export default {
  name: "FPProductManage",
  components: {
    formSearch,
    Table,
    blueBtn,
    iconBtn,
    Rectangle,
    TipsLabel,
    Pagination
  },
  data() {
    return {
      loading:false,
      isLoading:false,
      buttonLoading:false,
      exportFileLoading: false,
      totalAmount: 0,
      dialogTableVisible:false,
      tableSearch: [
        {
          label: "供应商名称",
          value: "demanderName",
          type: "text",
        },
        {
          label: "凭证编号",
          value: "accoutVoucherCode",
          type: "text",
        },
        {
          label: "总公司代码",
          value: "coreComUsci",
          type: "text",
        },
        {
          label: "公司代码",
          value: "companyCode",
          type: "text",
        },
        {
          type: "date",
          label: "AP到期日",
          apply: "date",
          children: [
            {
              value: "expiryDateStart",
              type: "startDate",
            },
            {
              value: "expiryDateEnd",
              type: "endtDate",
            },
          ],
        },

        // {
        //   type: "date",
        //   label: "迪链到期日",
        //   apply: "date",
        //   children: [
        //     {
        //       value: "beginDueDate",
        //       type: "startDate",
        //     },
        //     {
        //       value: "endDueDate",
        //       type: "endtDate",
        //     },
        //   ],
        // },
         {
          type: "date",
          label: "同步日期",
          apply: "date",
          children: [
            {
              value: "btchDateStartStr",
              type: "startDate",
            },
            {
              value: "btchDateEndStr",
              type: "endtDate",
            },
          ],
        },
        {
          label: "借/贷方",
          value: "borrower",
          type: "select",
          children: [
            {
              value: "0",
              label: "借",
            },
            {
              value: "1",
              label: "贷",
            },
          ],
        },
        {
          label: "付款方式",
          value: "zlsch",
          type: "select",
          children: [
            {
              label: "银行承兑汇票",
              value: "0",
            },
            {
              label: "支票",
              value: "1",
            },
            {
              label: "进口托收",
              value: "2",
            },
            {
              label: "BYD迪链",
              value: "3",
            },
            {
              label: "现金",
              value: "4",
            },
            {
              label: "T/T",
              value: "5",
            },
            {
              label: "商业承兑汇票",
              value: "6",
            },
            {
              label: "信用证",
              value: "7",
            },
          ],
        },
        {
          label: "是否有效",
          value: "isValid",
          type: "select",
          children: [
            {
              value: "1",
              label: "是",
            },
            {
              value: "0",
              label: "否",
            },
          ],
        },
        {
          label: "资源类型",
          value: "packageType",
          type: "select",
          children: [
            {
              label: "应付账款",
              value: "0",
            },
            {
              label: "应付资产",
              value: "1",
            },
            {
              label: "预付材料",
              value: "2",
            },
            {
              label: "预付资产",
              value: "3",
            },
          ],
        },
        {
          label: "数据来源",
          value: "btchWay",
          type: "select",
          children: [
            {
              label: "线下导入",
              value: "0",
            },
            {
              label: "SAP系统同步",
              value: "1",
            },
            {
              label: "OA签发",
              value: "2",
            },
          ],
        },
      ],
      tableProp: [
        {
          code: "coreComUsci",
          label: "总公司代码",
          minWidth: "150"
        },
        {
          code: "companyCode",
          label: "公司代码",
          minWidth: "150"
        },
        {
          code: "demanderName",
          label: "供应商名称",
          minWidth: "250"
        },
        {
          code: "demanderCode",
          label: "供应商代码",
          minWidth: "150"
        
        },
        {
          code: "prctr",
          label: "利润中心",
          minWidth: "100"
        },
        {
          code: "fiscalYear",
          label: "会计年度",
          minWidth: "100"
        },
        {
          code: "accoutVoucherCode",
          label: "凭证编号",
          minWidth: "150"
        },
        {
          code: "accoutVoucherLines",
          label: "行项目",
          minWidth: "120"
        },
        {
          code: "packageType",
          label: "资源类型",
          minWidth: "120"
        },
        {
          code: "currency",
          label: "币种",
          minWidth: "100"
        },
        {
          code: "amount",
          label: "金额",
          minWidth: "150"
        },
        {
          code: "accountPeriod",
          label: "票据期限",
          minWidth: "100"
        },
        {
          code: "augdt",
          label: "过账日期",
          minWidth: "150"
        },
        {
          code: "dueDate",
          label: "AP到期日",
          minWidth: "150"
        },
        // {
        //   code: "dlDueDate",
        //   label: "迪链到期日",
        //   minWidth: "150"
        // },
        // {
        //   code: "applyDate",
        //   label: "会计审核日期",
        //   minWidth: "150"
        // },
        // {
        //   code: "creater",
        //   label: "会计",
        //   minWidth: "100"
        // },
        // {
        //   code: "applyDate",
        //   label: "对账员",
        //   minWidth: "150"
        // },
        {
          code: "creater",
          label: "对账员工号",
          minWidth: "150"
        },
        {
          code: "btchWay",
          label: "数据来源",
          minWidth: "150"
        },
        {
          code: "btchDate",
          label: "同步日期",
          minWidth: "150"
        },
        // {
        //   code: "remark1",
        //   label: "备注",
        //   minWidth: "150"
        // },
        {
          code: "zlsch",
          label: "付款方式",
          minWidth: "120"
        },
        {
          code: "borrowFlag",
          label: "借/贷标识",
          minWidth: "100"
        },
        {
          code: "zlspr",
          label: "是否冻结",
          minWidth: "100"
        },
        {
          code: "isEffective",
          label: "是否有效",
          minWidth: "100"
        },
        {
          code: "status",
          label: "状态",
          minWidth: "100"
        },
      ],
      tableData: [],
      pageObj: {
        currentPage: 1,
        total: 0,
        size:50
      },
      pageSizes:[50,200,500],
      tableLg: "",
      searchObj: {},
      fileList2: [],
      exportParams:{},
      checkedAmount: utif.moneyFLoatFormat(0),
      seletionData: [],
      baseUrl: ''
    };
  },
  created() {
    console.log('baseurl',this.$BASEURL)
    this.baseUrl = this.$BASEURL
    // this.getTableData();
  },
  methods: {
    async handleImport() {
      let isNamesProps = await getNamesProps('sourceImport')
      if (!isNamesProps) {
        this.$message.warning('无权限操作！');
        return
      }
      this.dialogTableVisible = true;
    },
    handleChange(val) {
      // //table选择
      this.seletionData = [...val];
      // let element = 0;
      // for (let index = 0; index < this.seletionData.length; index++) {
      //   element += parseFloat(this.seletionData[index].amount2);
      // }
      // this.checkedAmount = utif.moneyFLoatFormat(element);
      this.checkedAmount = this.$utif.selectedSumOfMoney(val,"amount2");
    },
    templateDownload(){
      const url = this.$BASEURL + `/ac/account/download/account/template `
      this.$exportFileFunc("模板下载", ".xlsx", url, "post");  
    },
    myUploadMethod(file){
    this.buttonLoading = true;
    this.$UPLOAD("/ac/accounts/resource/synchronal", file.file).then(
        (res) => {
          if (res.ret == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            // this.ruleForm.vCode = res.id
          } 
          this.buttonLoading = false;
          // else {
          //   if (res.msg) {
          //     this.$message.error(res.msg);
          //   } else {
          //     this.$message.error(res.message);
          //   }
          // }
        }

      );
    },
    setPage(val,size) {
      //切换到下一页
      this.pageObj.currentPage = val;
      this.pageObj.size = size;
      this.getTableData(this.searchObj);
    },
    // handleSizeChange(val) {
    //   this.pageObj.size = val;
    //   this.getTableData(this.searchObj);
    // },
    getTableData(addedParams = {}) {
      this.loading = true;
      this.tableData = [];
      const params = {
        filterData: {
          companyCode: "",
          multiTenancyCd: "",
          demanderCodeList: [],
          coreComUsci: "", //总公司代码
          docNo: "", //凭证编号
          // beginDate: '',
          // endDate: '',
          packageType: "",
          accountDate: "", //应付账款到期日,
          beginDueDate: "",
          endDueDate: "",
          borrower: "",
          payWay: "",
          isValid: '1',
          dataSource: "",
          ...addedParams,
        },
        pageData: {
          page: this.pageObj.currentPage,
          pageSize: this.pageObj.size,
        },
      };
      this.exportParams = JSON.parse(JSON.stringify(params));
      this.$POST(this.submember["001"], params)
        .then((res) => {
          console.log("ac-res0217", res);
          if (res && res.data) {
            this.tableData = res.data.content
              ? JSON.parse(JSON.stringify(res.data.content))
              : [];
            this.pageObj.total = res.data.totalElements;
            let totalAmount =  res.data.totalAmount  || 0 
            this.totalAmount = utif.moneyFLoatFormat(totalAmount)
            this.tableLg = res.data.totalElements;
            //字段格式化todo
             if(this.tableData.length>0){
               this.tableData.forEach((el) => {
              el.isEffective = el.isValid == '1' ?"是":"否"
              el.zlspr = el.zlspr ? "冻结" : "非冻结";
              el.status = "正常";
              el.borrowFlag = Number(el.amount) > 0 ? "贷" : "借";
              el.amount2 = el.amount;
              el.amount = utif.moneyFLoatFormat(el.amount);
              el.dueDate = utif.cliceTime(el.dueDate);
              el.dlDueDate = utif.cliceTime(el.dlDueDate);
              el.createTime = utif.cliceTime(el.createTime);
              el.expiryDate = utif.cliceTime(el.expiryDate);
              el.augdt = utif.cliceTime(el.augdt);
              el.btchDate = utif.cliceTime(el.btchDate);
              el.zlsch =  utif.payWay(el.zlsch);
              // el.currency = utif.currencyType(el.currency);
              el.btchWay = utif.packageSource(el.btchWay);
              el.packageType2 = el.packageType;
              el.packageType = utif.packageType(el.packageType);
            });
          }
             }
          this.loading = false;
        })
        .catch((err) => {
          console.log("ac-err0217", err);
          this.loading = false;
        });
    },
    uploadData () {//同步数据
      console.log('uploadData同步')
      this.isLoading = true;
      const addParams = {
        // lastModifyUser: 'SYSTEM'//todo
      }
      this.$POST(this.submember["012"], {
        date: this.$utif.makeTime(new Date().getTime()),
        // packageId: '',
        // multiTenancyCd: 'BYD',
        // issueStatus: '0',
        ...addParams
      }).then(res => {
        console.log('tongbu-data',res)
        if (res) {
          this.$message(`同步数据${res.msg}`)
        }
        this.isLoading = false;
      }).catch(err => {
        console.log('tongbu-err',err)
        // this.$message(err)
        this.isLoading = false;
      })
    },
    // 接收的事件
    handleSearch(val) {
      
      this.searchObj = val;
      this.searchObj.demanderCodeList = [];
      if (val.demanderCode) {
        this.searchObj.demanderCodeList.push(val.demanderCode);
      }
      console.log("handleSearch-val", this.searchObj);
      this.getTableData(this.searchObj)
    },
    handleReset() {
      this.searchObj = {};
      this.getTableData(this.searchObj)
    },
    handleEdit(index, row) {},
    exportData() {//导出
      // const addedParams = {
      //   beginDate: this.searchObj.beginDueDate,
      //   endDate: this.searchObj.endDueDate
      // }
      // const params = {
      //   companyCode: "",
      //   multiTenancyCd: "",
      //   demanderCode: "",
      //   ...addedParams
      // };
      this.$exportFileFunc('成员企业-资源明细列表','.xlsx', this.submember["010"], 'post', this.exportParams)
    },
    uploadSuccess2(res, file, fileList) {//导入
      if (res.ret == 0) {
        this.fileList2 = [
          {
            name: file.name,
            fileId: file.response.data.fileId,
          },
        ];
        this.$message.success(res.msg);
      } 
      // else {
      //   this.$message.error(res.msg);
      // }
    },
    upError(res) {
      console.log("上传失败", res);
    },
  },
};
</script>
<style lang="less" scoped>
.btn2 {
  // float: right;
  margin-right: 6px;
}
.btn3 {
  margin-right: 6px;
}
.rowStyle {
  height: 40px;
  margin: 10px 0px;
}
.header {
  margin-top: 8px;
  // padding: 32px 38px 39px 48px;
  background-color: #fff;
  box-shadow: 0px 0px 10px #E5E8F2;
}
.footer {
  width: auto;
  margin-top: 13px;
  padding-top: 13px;
  padding: 16px 48px 0px;
  background-color: #fff;
  height: auto;
  box-shadow: 0px 0px 10px #E5E8F2;

  .tip {
    margin-top: 12px;
    margin-bottom: 18px;
    line-height: 1.5;
  }
}
</style>